import { useMutation, useQueryClient } from "@tanstack/react-query";
import { PortfolioKeys } from "web_myplann/Api/Portfolio/portfolioKeys";
import {
	type ClientPortfolioDetailResponseDTO,
	type ClientPortfolioLifeInsuranceEditRequestDTO,
	patchPortfolioLifeInsuranceIdV2,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const usePatchPortfolioLifeInsuranceMutation = (id: number) => {
	const queryClient = useQueryClient();

	return useMutation<
		ClientPortfolioDetailResponseDTO,
		Error,
		Partial<ClientPortfolioLifeInsuranceEditRequestDTO>
	>({
		mutationFn: processResponse((requestContract) =>
			patchPortfolioLifeInsuranceIdV2(requestContract, id),
		),
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: PortfolioKeys.portfolioList(),
			});
			queryClient.invalidateQueries({
				queryKey: PortfolioKeys.portfolioDetail(id),
			});
		},
	});
};
